module.exports = __webpack_public_path__ + "img/saxion-logo.950697ad.png";